import React from 'react';
import { CalendarIcon, TrendingDownIcon, BrainIcon, MoonIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-228">
      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-229">
        <div className="text-center mb-12" data-id="element-230">
          <div className="inline-flex items-center justify-center space-x-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full font-bold text-sm mb-4" data-id="element-231">
            <CalendarIcon className="h-4 w-4" data-id="element-232" />
            <span data-id="element-233">Resultados Rápidos</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-234">
            Lo que cambia en <span className="text-teal-600" data-id="element-235">7 días</span>
          </h2>
        </div>

        <div className="bg-stone-50 rounded-3xl p-8 md:p-12 shadow-inner border border-stone-200" data-id="element-236">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-237">
            <div className="flex flex-col items-center text-center space-y-4" data-id="element-238">
              <div className="w-16 h-16 bg-white rounded-full shadow-md flex items-center justify-center text-teal-600" data-id="element-239">
                <TrendingDownIcon className="h-8 w-8" data-id="element-240" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-241">
                Ropa más holgada
              </h3>
              <p className="text-gray-600" data-id="element-242">
                Notarás que tu ropa te queda más holgada en la cintura, no
                porque hayas perdido 5 kilos de grasa, sino porque habrás
                eliminado litros de inflamación sistémica que tu cuerpo retenía
                como defensa.
              </p>
            </div>

            <div className="flex flex-col items-center text-center space-y-4" data-id="element-243">
              <div className="w-16 h-16 bg-white rounded-full shadow-md flex items-center justify-center text-teal-600" data-id="element-244">
                <BrainIcon className="h-8 w-8" data-id="element-245" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-246">
                Claridad Mental
              </h3>
              <p className="text-gray-600" data-id="element-247">
                Tu mente se sentirá clara. La "niebla mental" que te impedía
                concentrarte por las tardes desaparecerá, dándote energía
                sostenida todo el día.
              </p>
            </div>

            <div className="flex flex-col items-center text-center space-y-4" data-id="element-248">
              <div className="w-16 h-16 bg-white rounded-full shadow-md flex items-center justify-center text-teal-600" data-id="element-249">
                <MoonIcon className="h-8 w-8" data-id="element-250" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-251">
                Sueño Reparador
              </h3>
              <p className="text-gray-600" data-id="element-252">
                Tu sueño será, por fin, reparador. Dejarás de despertarte a las
                3 AM con el corazón acelerado y la mente llena de
                preocupaciones.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}